module.exports = __webpack_public_path__ + "img/Japan-2021.abfaf537.png";